import { useTranslation } from 'react-i18next';
import { MenuLinkItem } from 'ui';
import type { NavigationMenuItemConfig } from '../hooks';

const NavigationMenuLabel = ({ config }: { config: NavigationMenuItemConfig }) => {
  const { t } = useTranslation();

  return <MenuLinkItem text={t(config.text)} to={config.href} />;
};

export default NavigationMenuLabel;
